import * as React from 'react'
import { OverviewCard } from 'src/pages/org-position-page/overview-cards/overview-card'
import { Sparkle } from '@phosphor-icons/react'

export type TeamOverviewCardType = 'total' | 'issues'

export type TeamOverviewCardsProps = {
  onClick: (cardType: TeamOverviewCardType) => void
  selectedCard: TeamOverviewCardType
  setSelectedCard: (cardType: TeamOverviewCardType) => void
  totalTeams: number
  teamsWithIssues: number
}

export const TeamOverviewCards = (props: TeamOverviewCardsProps) => {
  const {
    onClick,
    selectedCard,
    setSelectedCard,
    totalTeams,
    teamsWithIssues,
  } = props

  const selectCard = (cardType: TeamOverviewCardType) => {
    onClick(cardType)
    setSelectedCard(cardType)
  }

  const selected = (cardType: TeamOverviewCardType) => selectedCard === cardType

  return (
    <div className="flex gap-3 bg-gray-50 text-green-600 items-center p-3 overflow-x-auto">
      <Sparkle size={20} weight="fill" className="flex-shrink-0" />
      Quick filters
      <OverviewCard
        description="All Teams"
        filterText="Show all teams"
        onClick={() => selectCard('total')}
        selected={selected('total')}
        value={totalTeams}
      />
      <OverviewCard
        description="Teams with Issues"
        filterText="Show teams"
        onClick={() => selectCard('issues')}
        selected={selected('issues')}
        tooltipText="Teams with health audit issues"
        value={teamsWithIssues}
      />
    </div>
  )
}
